import React from 'react'
import { Modal, Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import { connect } from "react-redux";
import { changeDeliverClassName, clearProductOutwardAction, createPoInward, getProjectOutwardList, getExecutiveUrl } from '../../../actions';
import { toast } from 'react-toastify';
import Spinner from '../../../Components/loader';
import Search from "../../../assets/images/search.svg";
import close from "../../../assets/images/close.svg";

class Projects extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            quotationId: "",
            items: [],
            inwardData: [],
            allData: []
        }
        this.productHandler = this.productHandler.bind(this);
        this.selectHandler = this.selectHandler.bind(this);
        this.selectProHandler = this.selectProHandler.bind(this);
        this.changeHandler = this.changeHandler.bind(this);
        this.submitHandler = this.submitHandler.bind(this);
        this.searchHandler = this.searchHandler.bind(this);
        this.searchTimeout = null;
    }
    selectHandler(e) {
        const { openedItem } = this.state;
        let newItems = openedItem.map((i) => i = e.target.checked);
        this.setState({
            openedItem: newItems,
        })
    }
    selectProHandler(e, index) {
        const { openedItem } = this.state;
        let newItems = openedItem.map((item, i) => index === i ? e.target.checked : item);
        this.setState({
            openedItem: newItems
        })
    }
    changeHandler = (e, index) => {
        const { data } = this.state;
        let a = Number(data[index].quantity);
        let b = Number(e.target.value);
        if (b < a) {
            data[index].inwardQuantity = e.target.value;
            data[index].balance = data[index].quantity - Number(e.target.value);
            this.setState({
                data: data
            })
        } else {
            toast("Pls enter the number less than quantity");
        }
    }
    productHandler(e) {
        this.props.inwardData?.map((item) => {
            if (item?.purchaseOrderId == e.target.value) {
                let data = [];
                item?.projectList.map((val) => {
                    data.push(val);
                })
                this.setState({
                    data: data,
                    purchaseOrderId: item?.purchaseOrderId
                })
            }
        });
    }
    submitHandler() {
        const { data } = this.state;
        let pro = [];
        data?.map((item, i) => {
            let items = {};
            items["productId"] = item.productId;
            items["projectId"] = item.projectId;
            items["stockQty"] = Number(item.inwardQuantity);
            pro.push(items);
        });
        let formData = pro;
        this.props.dispatch(createPoInward(formData));
    }

    searchHandler(e) {
        const searchKey = e.target.value;
        if (this.searchTimeout) {
            clearTimeout(this.searchTimeout);
        }
        this.searchTimeout = setTimeout(() => {
            this.props.onSearchProjects(searchKey);
        }, 500);
    }
    componentDidUpdate(prevProps) {
        if (prevProps.projectOutwardData !== this.props.projectOutwardData) {
            this.setState({
                data: this.props.projectOutwardData
            })
        }
    }

    componentWillUnmount() {
        if (this.searchTimeout) {
            clearTimeout(this.searchTimeout);
        }
    }

    render() {
        const { show, onHide, handleShow, onClearProjectOutward } = this.props;
        const { data } = this.state;
        return (
            <>
                <Modal
                    show={show}
                    size="xl"
                    onHide={() => {
                        onHide();
                        onClearProjectOutward();
                    }}
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    backdrop="static"
                    keyboard={false}
                >
                    <div className="modal-staff">
                        <div className="page-head-split">
                            <div className="head-colums" style={{ backgroundColor: "#f8f8f8", display: "flex", justifyContent: "space-between", alignItems: "center", padding: "0px 18px 0px 8px" }}>
                                <div className="head">
                                    <i class="fas fa-arrow-left" onClick={() => {
                                        onHide();
                                        onClearProjectOutward();
                                    }}></i>
                                    <h4>PROJECTS</h4>
                                </div >
                                <div className="customer-search" style={{ marginLeft: 'auto', paddingRight: "20px" }}>
                                    <span><img src={Search} alt=".." className="search-img" /></span>
                                    <Form.Control type="search" placeholder="Search" onChange={this.searchHandler} className="main-search" />
                                </div>
                                <span onClick={() => {
                                    onHide();
                                }}>
                                    <img src={close} alt="..." width="18px" style={{ cursor: "pointer" }} />
                                </span>
                            </div>
                        </div>
                        <div className="table-class space-part">
                            <table class="table table-borderless">
                                <thead>
                                    <tr>
                                        <th scope="col">
                                            BOQ No.
                                        </th>
                                        <th scope="col">
                                            Project Name
                                        </th>
                                        <th scope="col">
                                            Customer Name
                                        </th>
                                        <th scope="col" className='txt-center'>
                                            Status
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.props.load === true ? <Spinner /> :
                                        (data && data?.length !== 0) ? Array.isArray(data) ? data.map((item, i) => (
                                            <tr key={i} onClick={() => handleShow(item)} style={{ cursor: "pointer" }}>
                                                <td>{item.billOfQuantityNumber}</td>
                                                <td className='new_bulk_size'>
                                                    <OverlayTrigger overlay={<Tooltip id="tooltip-disabled"> {item.projectName || "-"}</Tooltip>}>
                                                        <span className="d-inline-block">
                                                            {item.projectName || "-"}
                                                        </span>
                                                    </OverlayTrigger>
                                                </td>
                                                <td>
                                                    {item.customerName || <div className="center_align"><p>-</p></div>}</td>
                                                <td className='txt-center'>
                                                    <button style={{ width: " 145px" }} className={changeDeliverClassName(item.status)} onClick={(e) => handleShow(item)} >
                                                        {item.status}
                                                    </button>
                                                </td>
                                            </tr>
                                        )) : (
                                            <tr onClick={() => handleShow(data)} style={{ cursor: "pointer" }}>
                                                <td>{data.billOfQuantityNumber}</td>
                                                <td className='new_bulk_size'>
                                                    <OverlayTrigger overlay={<Tooltip id="tooltip-disabled"> {data.projectName || "-"}</Tooltip>}>
                                                        <span className="d-inline-block">
                                                            {data.projectName || "-"}
                                                        </span>
                                                    </OverlayTrigger>
                                                </td>
                                                <td>
                                                    {data.customerName || <div className="center_align"><p>-</p></div>}</td>
                                                <td className='txt-center'>
                                                    <button style={{ width: " 145px" }} className={changeDeliverClassName(data.status)} onClick={(e) => handleShow(data)} >
                                                        {data.status}
                                                    </button>
                                                </td>
                                            </tr>
                                        ) : <h1 className="empty-data">No Records Found</h1>
                                    }
                                </tbody>
                            </table >
                        </div >
                    </div >
                </Modal >
            </>
        )
    }
}
function mapStateToProps(state) {
    return {
        convertBoqList: state.boq.convertBoqList,
        inwardData: state.po.inwardData,
        load: state.boq.load,
        confirmQuotDropdown: state.boq.confirmQuotDropdown,
        confirmQuotProduct: state.boq.confirmQuotProduct,
        addInwardData: state.po.addInwardData,
        projectOutwardData: state.boq.projectOutwardData
    }
}

const mapDispatchToProps = (dispatch) => ({
    onClearProjectOutward: () => dispatch(clearProductOutwardAction()),
    onSearchProjects: (searchParams) => dispatch(getProjectOutwardList(`searchKey=${encodeURIComponent(searchParams || '')}`)),
    dispatch: dispatch
})

export default connect(mapStateToProps, mapDispatchToProps)(Projects);
